import { render, staticRenderFns } from "./GoBackAtTop.vue?vue&type=template&id=6c9de599&scoped=true&"
import script from "./GoBackAtTop.vue?vue&type=script&lang=js&"
export * from "./GoBackAtTop.vue?vue&type=script&lang=js&"
import style0 from "./GoBackAtTop.vue?vue&type=style&index=0&id=6c9de599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9de599",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
